import React, { Component, Fragment } from "react";

import { Button, Form } from "react-bootstrap";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { DateRange } from 'components/common/formFields/DateRange'
import {DropDownSelect, MultiSelectContextMenu} from "../common";


/**
 * @author Teyim Pila <teyim.pila@gmail.com>
 * @date 10/12/2018 : 1:58 PM
 */

const dropdownStyles = {
    borderColor: "#c4c9c7",
    boxShadow: "none",
    color: "#5a5f5e"
};

class FilterForm extends Component {

    render() {

        const {
            submitting,
            handleSubmit,
            startDate,
            messagesAction,
            channelsAction,
            endDate,
            handleChange,
            channelsFilter,
            channelsIds,
            messagesFilter,
            handleChannelsFilterChange,
            onSubmit
        } = this.props;

        const messagesInput = {onChange: handleChange, value: messagesAction};
        const channelsInput = {onChange: handleChange, value: channelsAction};
        const channelOptions = channelsFilter && channelsFilter.length > 0 ? channelsFilter.map(channelFilter => {
            return {name: channelFilter.name, value: channelFilter.value}
        }) : []

        return (
            <Fragment>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <div>
                        <span className="font-14 color-grey-dark">Date</span>
                        <label className="calendar-today tms-inbox-calendar" style={{display: "block"}}>
                            <Field
                                submittedStartDate={startDate}
                                submittedEndDate={endDate}
                                name="dateRange"
                                type="text"
                                values={startDate}
                                component={DateRange}/>
                        </label>
                    </div>
                    <div style={{marginTop: "10px", display: "block"}}>
                        <span className="font-14 color-grey-dark">Messages</span>
                        <label className="" style={{display: "block"}}>
                            <Field
                                name="userActions"
                                fieldName="userActions"
                                type="text"
                                input={messagesInput}
                                style={dropdownStyles}
                                options={messagesFilter}
                                value={messagesAction}
                                component={DropDownSelect}/>
                        </label>
                    </div>
                    <div style={{marginTop: "10px", display: "block"}}>
                        <span className="font-14 color-grey-dark">Channels</span>
                        <div className="inbox-context-menu" style={{display: "block"}}>

                            <Field
                              name="channels"
                              fieldName="channels"
                              type="text"
                              displayName={'Channels'}
                              input={channelsInput}
                              options={channelOptions}
                              checkedOptions={channelsAction}
                              ids={channelsIds}
                              handleChange={handleChannelsFilterChange}
                              component={MultiSelectContextMenu} />

                        </div>
                    </div>

                    <div style={{marginTop:"20px"}}>
                        <Button className="btn btn-success btn-block font-15" type="submit" disabled={submitting}>
                            Apply
                        </Button>
                    </div>
                </Form>
            </Fragment>
        );
    }
}


function validate(values) {
    const errors = {};


    if (!values.dateRange || !values.userAction ) {
        errors.error = "No valid input"
    }

    return errors;
}


const mapStateToProps = (state) => {
    const { auth } = state;
    return {
        currentUser: auth,
    };
};

FilterForm = connect(mapStateToProps)(FilterForm);

const filterForm = reduxForm({
    form: 'FilterForm',
    validate,
    touchOnBlur: false
})(FilterForm);

export { filterForm as FilterForm }
